module.exports = __webpack_public_path__ + "img/40_00_083_005.9b18831c.jpg";